import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssnFormat'
})
export class SsnFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (value != null && value.length >= 9) {
      let ssnStripped = value.replace(/[^0-9]/g, '');
      return ssnStripped.substr(0, 3) + '-' + ssnStripped.substr(3, 2) + '-' + ssnStripped.substr(5, 4);
    }
    else {
      return value;
    }
  }

}
